import { Routes, Route } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import * as links from './utils/general_links.js';
import './App.css';
import ScrollToTop from './components/global/ScrollToTop.jsx';
import Header from './components/global/Header';
import CTABar from './components/global/CTABar.jsx';
import Footer from './components/global/Footer';
import * as Pages from './pages/export';

function App() {
	const location = useLocation();
	const showCtaBarInPages = [
		links.ROUTES.home,
		links.ROUTES.presentation,
		links.ROUTES.loiElan,
		links.ROUTES.quiSommesNous,
		links.ROUTES.faq
	];

	return (
		<>
			<ScrollToTop />
			<Header />
			<Routes>
				<Route path={links.ROUTES.home} element={<Pages.HomePage />} />
				<Route path={links.ROUTES.presentation} element={<Pages.Presentation />} />
				<Route path={links.ROUTES.loiElan} element={<Pages.LoiElan />} />
				<Route path={links.ROUTES.quiSommesNous} element={<Pages.QuiSommesNous />} />
				<Route path={links.ROUTES.espacePro} element={<Pages.EspacePro />} />
				<Route path={links.ROUTES.faq} element={<Pages.Faq />} />
				<Route path={links.ROUTES.contact} element={<Pages.Contact />} />
				<Route path={links.ROUTES.devis} element={<Pages.Devis />} />
				<Route path={links.ROUTES.planDuSite} element={<Pages.PlanSite />} />
				<Route path={links.ROUTES.mentionsLegales} element={<Pages.MentionsLegales />} />
				<Route path={links.ROUTES.politiqueCookies} element={<Pages.PolitiqueCookies />} />
				<Route path={links.ROUTES.politiqueProtection} element={<Pages.PolitiqueProtection />} />
			</Routes>
			{ showCtaBarInPages.includes(location.pathname) ? <CTABar /> : null }
			<Footer />
		</>
  	);
};

export default App;
